// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAnalytics, logEvent } from 'firebase/analytics';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAKdrDRa7WQ6YNN6yWvVf3TWblq_Oi8TDg",
  authDomain: "floresdelis-9419f.firebaseapp.com",
  projectId: "floresdelis-9419f",
  storageBucket: "floresdelis-9419f.firebasestorage.app",
  messagingSenderId: "41232722572",
  appId: "1:41232722572:web:a69303a19cd39fdcd2e9a9",
  measurementId: "G-24LJ24XNJ0"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics
let analytics = null;

// Solo inicializar analytics si estamos en el navegador
if (typeof window !== 'undefined') {
  analytics = getAnalytics(app);
}

// Función para trackear eventos personalizados
export const trackEvent = (eventName, parameters = {}) => {
  if (analytics) {
    logEvent(analytics, eventName, parameters);
  }
};

// Eventos específicos para tu negocio de flores
export const trackPageView = (pageName) => {
  trackEvent('page_view', {
    page_name: pageName
  });
};

export const trackSectionView = (sectionName) => {
  trackEvent('section_view', {
    section_name: sectionName
  });
};

export const trackImageGalleryView = (galleryType) => {
  trackEvent('gallery_view', {
    gallery_type: galleryType
  });
};

export const trackContactInteraction = (contactType) => {
  trackEvent('contact_interaction', {
    contact_type: contactType
  });
};

export const trackWorkshopInterest = (workshopName) => {
  trackEvent('workshop_interest', {
    workshop_name: workshopName
  });
};

export default app;
